import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'UI/res';

const TAB_BAR_HEIGHT = 48;
const ACTIVE_INDICATOR_HEIGHT = 2;

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    minHeight: 0
  },
  tabBar: {
    flexShrink: 0,
    backgroundColor: theme.palette.grey[50],
    borderBottom: `1px solid ${colors.inactiveSideBarTab}`,
    display: 'flex',
    height: TAB_BAR_HEIGHT
  },
  tab: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    position: 'relative'
  },
  tabLabel: {
    maxWidth: 96,
    width: '55%'
  },
  activeIndicator: {
    backgroundColor: theme.palette.grey[300],
    bottom: 0,
    height: ACTIVE_INDICATOR_HEIGHT,
    left: 0,
    position: 'absolute',
    right: 0
  },
  panel: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    minHeight: 0,
    padding: theme.spacing(3)
  },
  card: {
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: theme.shape.borderRadius * 2,
    flex: 1,
    overflow: 'hidden',
    padding: theme.spacing(3)
  },
  cardTitle: {
    height: 28,
    marginBottom: theme.spacing(2),
    width: 180
  },
  fieldLabel: {
    width: '40%'
  },
  fieldValue: {
    height: 24,
    width: '70%'
  }
}));
